"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var _BuilderThemeProvider = require("../BuilderThemeProvider");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette,
      zIndex = _ref.zIndex;
  return {
    footer: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 -1px 2px 0 ".concat(palette.grey.main),
      width: '100%',
      height: 74,
      zIndex: zIndex.appBar
    },
    chambray_Footer: {
      backgroundColor: palette.grey.chambray50
    },
    california_Footer: {
      backgroundColor: palette.additional.orange50
    },
    red_Footer: {
      backgroundColor: palette.red.light
    },
    green_Footer: {
      backgroundColor: palette.green.fruitSalad20
    },
    buttonsWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: spacing(8)
    },
    returnLink: {
      marginLeft: spacing(5),
      fontSize: 16,
      fontWeight: 'bold',
      color: palette.common.white
    },
    backButton: {
      color: palette.link.main,
      border: "1px solid ".concat(palette.divider),
      backgroundColor: palette.common.white,
      boxShadow: 'none'
    },
    nextButton: {
      marginLeft: spacing(4),
      boxShadow: 'none'
    },
    loading: {
      height: '20px!important',
      width: '20px!important'
    },
    tooltip: {
      backgroundColor: palette.common.white,
      color: palette.text.primary,
      padding: spacing(1.75, 2),
      maxWidth: 150,
      fontSize: 16,
      lineHeight: 1.5,
      boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.25)',
      fontWeight: 'normal'
    }
  };
});

var BuilderFooter = function BuilderFooter(_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$isLastStep = _ref2.isLastStep,
      isLastStep = _ref2$isLastStep === void 0 ? false : _ref2$isLastStep,
      _ref2$isFirstStep = _ref2.isFirstStep,
      isFirstStep = _ref2$isFirstStep === void 0 ? false : _ref2$isFirstStep,
      _ref2$onClickBack = _ref2.onClickBack,
      onClickBack = _ref2$onClickBack === void 0 ? undefined : _ref2$onClickBack,
      _ref2$theme = _ref2.theme,
      propsTheme = _ref2$theme === void 0 ? 'chambray' : _ref2$theme,
      onClickNext = _ref2.onClickNext,
      onClickReturn = _ref2.onClickReturn,
      wrap = _ref2.wrap;
  var classes = useStyles();

  var _useBuilderTheme = (0, _BuilderThemeProvider.useBuilderTheme)(),
      _useBuilderTheme$them = _useBuilderTheme.theme,
      theme = _useBuilderTheme$them === void 0 ? propsTheme : _useBuilderTheme$them;

  var nextButtonIcon = (0, _react.useMemo)(function () {
    return isLoading ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      classes: {
        root: classes.loading
      }
    }) : /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "arrow-right"
    });
  }, [classes, isLoading]);
  var Wrapper = wrap ? _material.Box : _react.default.Fragment;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    flex: "0 0 82px",
    height: 82
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.footer, classes["".concat(theme, "_Footer")])
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onClickReturn,
    variant: "text",
    className: classes.returnLink,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "arrow-left"
    })
  }, "Back to All Campaigns")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.buttonsWrapper
  }, !isFirstStep && onClickBack && /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onClickBack,
    variant: "contained",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "arrow-left"
    }),
    className: classes.backButton
  }, "Back"), disabled && !isLoading ? /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    title: "Please fill in all required fields",
    placement: "top",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onClickNext,
    type: onClickNext ? 'button' : 'submit',
    disabled: disabled,
    color: "primary",
    variant: "contained",
    endIcon: nextButtonIcon,
    className: classes.nextButton
  }, isLastStep ? 'Create campaign' : 'Next')) : /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: onClickNext,
    type: onClickNext ? 'button' : 'submit',
    disabled: disabled,
    color: "primary",
    variant: "contained",
    endIcon: nextButtonIcon,
    className: classes.nextButton
  }, isLastStep ? 'Create campaign' : 'Next'))));
};

var _default = BuilderFooter;
exports.default = _default;